import { Component, OnInit } from '@angular/core';
import { AnalysisService } from 'app/services/analysis.service';
import { ReportService } from 'app/services/report.service';
import { isHK } from 'app/app.component';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {
  hasData = false;
  now: number;

  constructor(
    private analysisService: AnalysisService,
    public reportService: ReportService
  ) { }


  ngOnInit() {
  }

  getIsHK(): boolean {
    return isHK;
  }

  getDate() {
    return this.now ;
  }

  getRoofArea() {
    return this.analysisService.getRoofArea();
  }

  /**
   * Zbiera informacje z pozostałych serwisów
   */
  generate() {
    this.reportService.collectData();
    this.hasData = true;
    this.now = Date.now();
  }

  /**
   * Uruchamia drukowanie
   */
  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          ./report.component.css
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }



}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/report/report.component.ts